/**
 * Status Bar Configuration
 * Controls the appearance of the native status bar on mobile devices
 */

import { StatusBar, Style } from '@capacitor/status-bar';
import { PLATFORM, PLATFORM_UI_CONFIG } from '../config/app.config';

/**
 * Initialize platform-specific CSS variables
 * Sets CSS custom properties for dynamic padding based on platform
 */
export const initializePlatformStyles = () => {
  const root = document.documentElement;
  
  // Set bottom navigation bar padding CSS variable
  const bottomPadding = PLATFORM_UI_CONFIG.getBottomNavBarPadding();
  root.style.setProperty('--platform-bottom-padding', `${bottomPadding}px`); 
};

/**
 * Initialize status bar appearance for native apps
 * Sets dark icons for light backgrounds
 */
export const initializeStatusBar = async () => {
  if (!PLATFORM.isNative) return;

  try {
    // Set status bar style to 'Light' which means DARK icons (for light backgrounds)
    // Style.Light = dark icons (for light backgrounds)
    // Style.Dark = light icons (for dark backgrounds)
    await StatusBar.setStyle({ style: Style.Light });

    // Set background color to match your app (white/light)
    await StatusBar.setBackgroundColor({ color: '#ffffff' });

    // Show the status bar if it's hidden
    await StatusBar.show();    
  } catch (error) {
    console.error('Error initializing status bar:', error);
  }
};

/**
 * Set status bar to dark mode (light icons)
 */
export const setStatusBarDark = async () => {
  if (!PLATFORM.isNative) return;
  
  try {
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setBackgroundColor({ color: '#000000' });
  } catch (error) {
    console.error('Error setting dark status bar:', error);
  }
};

/**
 * Set status bar to light mode (dark icons)
 */
export const setStatusBarLight = async () => {
  if (!PLATFORM.isNative) return;
  
  try {
    await StatusBar.setStyle({ style: Style.Light });
    await StatusBar.setBackgroundColor({ color: '#ffffff' });
  } catch (error) {
    console.error('Error setting light status bar:', error);
  }
};
